import type { Option } from '@contexts/shared/domain';

export enum LanguageOptions {
	ES = 'ES',
	EN = 'EN',
	PT = 'PT',
	IT = 'IT',
	FR = 'FR',
	DE = 'DE',
	EU = 'EU',
	NO = 'NO'
}

export type Language = `${LanguageOptions}`;

//TODO Por el momento hago la implementación de esta función en el frontend, pero tal vez deberíamos hacerla en el backend
export const languageNames: Record<LanguageOptions, string> = {
	[LanguageOptions.ES]: 'languages.es',
	[LanguageOptions.EN]: 'languages.en',
	[LanguageOptions.PT]: 'languages.pt',
	[LanguageOptions.IT]: 'languages.it',
	[LanguageOptions.FR]: 'languages.fr',
	[LanguageOptions.DE]: 'languages.de',
	[LanguageOptions.EU]: 'languages.eu',
	[LanguageOptions.NO]: 'languages.no'
};

export function getLanguages(): Language[] {
	return Object.values(LanguageOptions) as Language[];
}

export function getLanguageOptions(): Option<Language>[] {
	return getLanguages().map((language) => ({
		label: languageNames[language],
		value: language
	}));
}

export function normalizeLanguage(value?: string | null): Language {
	if (!value) return LanguageOptions.ES;
	const upper = value.toUpperCase();
	return (getLanguages() as string[]).includes(upper) ? (upper as Language) : LanguageOptions.ES;
}
